import * as quoteTypes from 'login/actions/loginActionTypes.js';

export default function quotesReducer(state = [], action) {
    switch (action.type) {
        case quoteTypes.SET_QUOTES:
            return action.quotes;

        default:
            return state;
    }
}
